import { FormControl, Input, Select } from '@visualfabriq/vf-ui-kit';

import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';

type Props = {
  fields: DataStagingStep.ValueArithmeticOperation;
  onUpdate: (fields: DataStagingStep.ValueArithmeticOperation) => void;
};

export function ValueArithmeticOperationMethod(props: Props) {
  const { fields, onUpdate } = props;

  return (
    <>
      <FormControl label="Operator" disabled={false} required>
        <Select
          options={Array.from(Object.values(DataStagingStep.ArithmeticOperators)).map((type) => ({
            id: type,
            label: type,
          }))}
          value={[{ id: fields.operator }]}
          onChange={(event) => {
            if (event.type !== 'select') return;
            onUpdate({
              ...fields,
              //@ts-expect-error AUTOMATICALLY GENERATED PLS FIX
              operator: event.value[0].id as DataStagingStep.ArithmeticOperators,
            });
          }}
        />
      </FormControl>

      <FormControl label="Operand" disabled={false} required>
        <Input
          value={fields.operand as unknown as number}
          type="number"
          placeholder="Enter a number to be used as operand"
          onChange={(event) =>
            onUpdate({
              ...fields,
              operand: Number.parseFloat(event.target.value),
            })
          }
        />
      </FormControl>
    </>
  );
}
